import React from 'react';
import Svg, { G, Path, ClipPath, Defs, Rect } from 'react-native-svg';

interface WelcomeMarkerIconProps {
  width?: number;
  height?: number;
}

const WelcomeMarkerIcon: React.FC<WelcomeMarkerIconProps> = ({
  width = 30,
  height = 41,
}) => (
  <Svg width={width} height={height} viewBox="0 0 30 41" fill="none">
    <G clipPath="url(#welcomeMarkerClip)">
      <Path
        d="M15 0C6.73077 0 0 6.52273 0 14.5364C0 22.55 15 41 15 41C15 41 30 22.55 30 14.5364C30 6.52273 23.2692 0 15 0ZM15 23.4818C9.90385 23.4818 5.76923 19.475 5.76923 14.5364C5.76923 9.59773 9.90385 5.59091 15 5.59091C20.0962 5.59091 24.2308 9.59773 24.2308 14.5364C24.2308 19.475 20.0962 23.4818 15 23.4818Z"
        fill="#FFE54F"
      />
      <Path
        d="M16.9231 6.33636L11.1539 15.6545H15.3846L13.0769 22.7364L19.6154 12.6727H15.3846L16.9231 6.33636Z"
        fill="#FFE54F"
      />
    </G>
    <Defs>
      <ClipPath id="welcomeMarkerClip">
        <Rect width="30" height="41" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default WelcomeMarkerIcon;
